<template>
  <div class="queryHistory">
    <box></box>
    <el-card shadow="never" class="allQuery" ref="allQuery">
      <div class="btnBox">
        <el-button icon="iconfont iconshangchuan1" class="btn1" @click="uploadFromController">{{$t('readAllHistory')}}</el-button>
        <el-button @click="handleConfirm" v-show="isShowCon == 1" class="btn-confirm">{{$t('confirm')}}</el-button>
        <el-button v-show="isShowCon == 2" @click="handleCancel" class="btn-confirm">{{$t('cancel')}}</el-button>
        <span class="status" v-show="uploadState == null">{{ $t('nostart') }}</span>
        <span class="status" v-show="uploadState == 0">{{ $t('completed')}}</span>
        <span class="status" v-show="uploadState == 2">{{  $t('fail')}}</span>
        <span class="status" v-show="uploadState == 1">{{ $t('processing')}}</span>
        <span class="current">{{$t('uploaded')}} {{current}} {{$t('item')}}</span>
      </div>
      <div class="linkageBottom" ref="linkageBottom">
        <el-form :inline="true" ref="searchForm" class="search-form">
          <el-form-item>
            <!-- <el-date-picker
                @change="selectTime"
                v-model="dateTime"
                type="daterange"
                :range-separator="$t('to')"
                :start-placeholder="$t('beginTime')"
                :end-placeholder="$t('endTime')">
            </el-date-picker> -->
             <el-date-picker
             @change="selectTime"
              v-model="dateTime"
              value-format="timestamp"
              type="datetimerange"
              :range-separator="$t('to')"
              :start-placeholder="$t('beginTime')"
              :end-placeholder="$t('endTime')">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.statType" clearable :placeholder="$t('statType')" filterable>
              <el-option
                  v-for="(value,key) in statTypeMap"
                  :key="key"
                  :label="value"
                  :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.devType" clearable :placeholder="$t('componentType')" filterable>
              <el-option
                  v-for="(value,key) in deviceTypeMap"
                  :key="key"
                  :label="value"
                  :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.addr" :placeholder="$t('addressTip')" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.descr" :placeholder="$t('noteTip')" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 90px" type="primary" :loading="searching" @click="queryHistory">{{$t('queryButton')}}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 90px" @click="_exportHistory" :loading="exporting">{{$t('export')}}</el-button>
          </el-form-item>
        </el-form>
        <el-table ref="basePageTable" :data="rows" :height="offsetWindowHeight" v-loading="searching">
          <el-table-column type="index" :label="$t('number')" :index="indexMethod" align="center"></el-table-column>
          <el-table-column prop="time" :label="$t('time')" align="center"></el-table-column>
          <el-table-column prop="devType" :label="$t('equipmentType')" align="center"></el-table-column>
          <el-table-column prop="addr" :label="$t('address')" align="center"></el-table-column>
          <el-table-column prop="stat" :label="$t('event')" align="center"></el-table-column>
          <el-table-column prop="descr" :label="$t('annotation')" align="center"></el-table-column>
          <!--el-table-column prop="analogValue" :label="$t('analog')" align="center"-->
          </el-table-column>
        </el-table>
        <el-pagination ref="basePagination" class="pagination" @size-change="handleSizeChange" background
                        @current-change="handleCurrentChange"
                        :page-sizes="pageSizes"
                        :page-size.sync="pageSize"
                        :current-page.sync="pageNumber"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog
        :title="$t('readAllHistory')"
        :visible.sync="dialogVisible">
      <el-form :inline="true" ref="searchForm" class="search-form">
        <el-form-item>
          <!-- <el-date-picker
              @change="selectTime"
              v-model="dateTime"
              type="daterange"
              :range-separator="$t('to')"
              :start-placeholder="$t('beginTime')"
              :end-placeholder="$t('endTime')">
          </el-date-picker> -->
           <el-date-picker
             @change="selectTime"
              v-model="dateTime"
              value-format="timestamp"
              type="datetimerange"
              :range-separator="$t('to')"
              :start-placeholder="$t('beginTime')"
              :end-placeholder="$t('endTime')">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
           <el-select v-model="searchForm.statType" clearable :placeholder="$t('statType')" filterable>
              <el-option
                v-for="(value,key) in statTypeMap"
                :key="key"
                :label="value"
                :value="key">
              </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="_controllerUpload">{{$t('confirm')}}</el-button>
      <el-button @click="dialogVisible = false">{{$t('cancel')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BasePage from "@/components/BasePage";
import Box from "@/components/Box";
import jbf from "assets/img/box/jbf.png";
import {getHistory, controllerUpload, exportHistory,compelte,cancel} from "api/query";
//import moment from "moment";
import {getSchedule} from "@/api/query"
import {stampToDateTime} from "assets/utils";
import Status from "components/Status";
export default {
  name: "historyRecord",
  mixins: [BasePage, Status],
  components: {
    Box
  },
  data() {
    return {
      value: '',
      num: 1,
      searchForm: {
        beginTime: '',
        endTime: '',
        descr: '',
        devType: '',
        addr: '',
        statType: ''
      },
      dateTime: [],
      jbf,
      bottomHeight: null,
      dialogVisible: false,
      current: 0,
      uploadState:null,
      exporting: false,
      rows:null,
      isShowCon:0
    }
  },
  computed: {
    controllInfo() {
      return this.$store.state.controlInfo
    },
    deviceTypeMap() {
       let list = this.$store.state.deviceTypeOptions
       return this.codeToName(list, "code", "name");
    },
    statMap() {
       let list = this.$store.state.statOptions
       return this.codeToName(list, "code", "name");
    },
    statTypeMap() {
       let list = this.$store.state.statTypeOptions
       return this.codeToName(list, "code", "name");
    },
  },
  watch: {
    // language(newval) {
    //   this.uploadState = this.$t('nostart')
    // },
    $route:{
        handler(val,oldval){
            clearInterval(this.timer)
        },
        deep: true
    },
  },
  created() {
    const date = new Date()
    this.dateTime = [date.setHours(0, 0, 0), date.setHours(23, 59, 59)]
    this.selectTime(this.dateTime)
  },
   beforeRouteEnter(to, from, next) {
    next(vm => {
      vm._getSchedule()
    })
  },
  beforeDestroy(){
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    selectTime (dateArr) {
      console.log(dateArr)
      if (Array.isArray(dateArr) && dateArr.length > 0) {
        this.searchForm.beginTime = dateArr[0].toString().substr(0,10)
        //moment(dateArr[0]).format('X')
        this.searchForm.endTime = dateArr[1].toString().substr(0,10)
        //moment(dateArr[1]).format('X')
      } else {
        this.searchForm.beginTime = ''
        this.searchForm.endTime = ''
      }
    },
    codeToName(list, key, name){
      let res = {}
      list.forEach(v => {
        if (!res[v[key]]) {
          res[v[key]] = v[name];
        }
      })
      return res
    },
    uploadFromController() {
      this.dialogVisible = true
    },
    getRows() {
      if (this.rows == null) {
        return
      }
      this._getHistoryList()
    },
    queryHistory() {
      this.searching = true
      this._getHistoryList()
    },
    _getHistoryList() {
      let searchParams = {
        beginTime: this.searchForm.beginTime,
        endTime: this.searchForm.endTime,
        controllerPsn:  this.controllInfo.controllerPsn,
        pageNum: this.pageNumber,
        pageSize: this.pageSize
      }
      if (this.searchForm.statType !== '') {
        searchParams.statType = this.searchForm.statType
      }
      if (this.searchForm.devType !== '') {
        searchParams.devType = this.searchForm.devType
      }
      if (this.searchForm.addr !== '') {
        searchParams.addr = this.searchForm.addr
      }
      if (this.searchForm.descr !== '') {
        searchParams.descr = this.searchForm.descr
      }
      getHistory(searchParams).then((res) => {
        if (res.code === 1) {
          res.data.forEach((item) => {
            item.time = stampToDateTime(item.time)
            item.stat = this.statMap[item.stat]
            item.devType = this.deviceTypeMap[item.devType]
          })
          this.total = res.total
          this.rows = res.data
          this.searching = false
        }
      }).catch(() => {
        this.failed()
        this.searching = false
      })
    },
    _exportHistory() {
      this.exporting = true
      this.show()
      let params = {
        beginTime: this.searchForm.beginTime,
        endTime: this.searchForm.endTime,
        controllerPsn:  this.controllInfo.controllerPsn,
      }
      if (this.searchForm.statType !== '') {
        params.statType = this.searchForm.statType
      }
      if (this.searchForm.devType !== '') {
        params.devType = this.searchForm.devType
      }
      if (this.searchForm.addr !== '') {
        params.addr = this.searchForm.addr
      }
      if (this.searchForm.descr !== '') {
        params.descr = this.searchForm.descr
      }

      let metas = [
        {
          "label": this.$t('psn'),
          "prop": "controllerPsn"
        },
        {
          "label": this.$t('time'),
          "prop": "time"
        },
        {
          "label": this.$t('equipmentType'),
          "prop": "devType"
        },
        {
          "label": this.$t('address'),
          "prop": "addr"
        },
        {
           "label": this.$t('event'),
           "prop": "stat"
        },
        {
           "label": this.$t('annotation'),
           "prop": "descr"
        }
      ]
      let searchParam = {
        "params": params,
        "metas": metas
      }
      exportHistory(searchParam).then((res) => {
        if (res.code === 1) {
          this.success(res.message ? res.message : '操作成功')
          this.exporting = false
        }
      }).catch(() => {
        this.failed()
        this.exporting = false
      })
    },
    _getSchedule() {
        getSchedule({
          controllerPsn: this.controllInfo.controllerPsn,
          type: 4
        }).then((res) => {
            if (res.code === 1) {
              if (res.data != null) {
                if (res.data.current != null) {
                  this.current = res.data.current
                }
                //this.isShowCon = 2
                if (res.data.state === 0) {
                  this.uploadState = 0
                } else if (res.data.state === 2) {
                  this.uploadState = 2
                } else if (res.data.state === 1) {
                  this.uploadState = 1
                }
                const _this = this
                this.timer = setInterval(() => {
                  if (res.data.state === 0 || res.data.state === 2) {
                  this.isShowCon = 1
                  clearInterval(this.timer)
                  } else if (res.data.state === 1) {
                    this.isShowCon = 2
                  _this.handleRefresh()
                  }
              }, 2000)
              } else {
                this.uploadState = null
              }
            }
        })
    },
    handleRefresh() {
        getSchedule({
          controllerPsn: this.controllInfo.controllerPsn,
          type: 4
        }).then((res) => {
            if (res.code === 1) {
              if (res.data != null) {
                if (res.data.current != null) {
                  this.current = res.data.current
                }
                if (res.data.state === 0) {
                  this.isShowCon = 1
                  clearInterval(this.timer)
                  this.uploadState = 0
                } else if (res.data.state === 2) {
                  this.isShowCon = 1
                  clearInterval(this.timer)
                  this.uploadState = 2
                } else if (res.data.state === 1) {
                  this.isShowCon = 2
                  this.uploadState = 1
                }
              }
            }
        })
    },
    _controllerUpload() {
      this.rows = null
      let searchParams = {
        beginTime: this.searchForm.beginTime,
        endTime: this.searchForm.endTime,
        controllerPsn:  this.controllInfo.controllerPsn
      }
      if (this.searchForm.statType !== '') {
        searchParams.statType = this.searchForm.statType
      }
      // 1:descr 2:program 3:upgrad 4:history
      controllerUpload(searchParams).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.message ? res.message : '操作成功')
          this._getSchedule()
        }
      })
      this.dialogVisible = false
    },
    handleConfirm(){
    compelte({
            controllerPsn: this.controllInfo.controllerPsn,
            type: 4
          }).then((res) => {
            if (res.code === 1) {
              this.isShowCon = 0
              this.uploadState = null
              this.current = 0
              this._getHistoryList()
            }
          })
    },
    handleCancel(){
    cancel({
            controllerPsn: this.controllInfo.controllerPsn,
            type: 4
          }).then((res) => {
            if (res.code === 1) {
              clearInterval(this.timer)
              this.isShowCon = 0
              this.current = 0
              this.uploadState = null
              this._getHistoryList()
            }
          })
    }
  }
}
</script>

<style lang="scss" scoped>
.queryHistory{
  .allQuery {
    position: relative;
    margin-bottom: 10px;
    .btnBox{
      .btn-confirm{
        float: right;
      }
      margin-bottom: 10px;
      .iconshangchuan1,.btn1{
        color: #00BEFF;
      }
      .iconshangchuan1{
        font-size: 18px;
      }
      .btn1{
        border: none;
        padding-left: 0px;
      }
      .current{
        color: #606266;
        float: right;
        line-height: 30px;
      }
      .status{
        color: #606266;
        float: right;
        padding: 0 8px;
        line-height: 30px;
      }
    }
    .linkageBottom{
      height: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
